import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { Layout } from '../components/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const TermsOfService = () => {
  const [loading, setLoading] = useState(true);
  const [tos, setTos] = useState(null);

  useEffect(() => {
    document.title = 'Terms of Service - SIYAK';
  }, []);

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/public/tos`);
        if (mounted) {
          setTos(response.data);
        }
      } catch {
        if (mounted) {
          setTos(null);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    load();
    return () => {
      mounted = false;
    };
  }, []);

  const shortHash = useMemo(() => {
    const hash = tos?.tos_hash || '';
    if (!hash) return '—';
    return hash.slice(0, 8);
  }, [tos?.tos_hash]);

  const contentBlocks = useMemo(() => {
    const content = tos?.content || '';
    return content
      .split(/\n\s*\n/)
      .map((block) => block.trim())
      .filter(Boolean);
  }, [tos?.content]);

  return (
    <Layout>
      <div className="bg-navy-50 min-h-screen">
        <div className="max-w-4xl mx-auto px-4 md:px-8 py-10 space-y-4">
          <Card>
            <CardHeader>
              <CardTitle className="font-heading text-2xl">Terms of Service</CardTitle>
            </CardHeader>
            <CardContent className="space-y-2 text-sm">
              {loading ? (
                <p>Loading terms…</p>
              ) : (
                <>
                  <p><strong>Version:</strong> {tos?.version || '—'}</p>
                  <p><strong>Hash:</strong> {shortHash}</p>
                  <p><strong>Last updated:</strong> {tos?.updated_at ? new Date(tos.updated_at).toLocaleString() : '—'}</p>
                  <div className="rounded-md border bg-background p-4 text-sm leading-7">
                    {contentBlocks.length ? (
                      <div className="space-y-4">
                        {contentBlocks.map((block, index) => (
                          <div key={`${index}-${block.slice(0, 24)}`} className="whitespace-pre-line">
                            {block}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div>Terms are temporarily unavailable.</div>
                    )}
                  </div>
                </>
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  );
};
